// 全局常量文件

export const common = {
    sdkVersion: '1.0.0',
    signType: 'md5'
}

// 东南亚
export const zth = {
    name: 'zth',
    area: 'sea',
    email: 'zth.pixelsaga@gmail.com',
    activityLabel: 'tM8PjGtFc1H4Y0EKU04J',
    // 服务器时间
    serverTime: '',
    // 服务器时间与客户端时间 差值
    differenceTime: '',
    // 初始化key，header头保持使用这个
    initKey: 'Rrssz4fZuoANo9xPawytk6xduUeWTcd7',
    aesKey: 'EtKwpGbpjinPujNpCE2z3DXlYBoZbqDN',
    // 初始化接口返回key，真实接口使用
    appKey: '',
    // 公钥
    publickey: '',
    // 私钥
    privateKey: ''
}

// 欧美
export const nazth = {
    name: 'nazth',
    area: 'na',
    email: 'zth.pixelsaga@gmail.com',
    activityLabel: 'fZhV3djInWuyGdkR',
    // 服务器时间
    serverTime: '',
    // 服务器时间与客户端时间 差值
    differenceTime: '',
    // 初始化key，header头保持使用这个
    initKey: 'Rrssz4fZuoANo9xPawytk6xduUeWTcd7',
    aesKey: 'EtKwpGbpjinPujNpCE2z3DXlYBoZbqDN',
    // 初始化接口返回key，真实接口使用
    appKey: '',
    // 公钥
    publickey: '',
    // 私钥
    privateKey: ''
}

export const projectType = () => {
    if (process.env.VITE_APP_ID === 'zth') {
        return zth
    }
    if (process.env.VITE_APP_ID === 'nazth') {
        return nazth
    }
}